module.exports = __webpack_public_path__ + "img/1.fe76d3c3.png";